/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Pricing_OffInputs */

const fr_label_pricing_off = /** @type {(inputs: Label_Pricing_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masquée`)
};

const en_label_pricing_off = /** @type {(inputs: Label_Pricing_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hidden`)
};

/**
* | output |
* | --- |
* | "Hidden" |
*
* @param {Label_Pricing_OffInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const label_pricing_off = /** @type {((inputs?: Label_Pricing_OffInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Pricing_OffInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_label_pricing_off(inputs)
	return en_label_pricing_off(inputs)
});